import { messagesService } from "@dv5/api"
import { ReactionWidgetData } from "@dv5/domain"

export interface ChangeWidgetData {
    canvasId: string
    widgetId: string
    data: ReactionWidgetData
    patchedPaths: Array<string>
}

export const useReactionWidgetUpdate = (
    canvasId: string,
    widgetId: string,
    data: ReactionWidgetData
) => {
    const updateData = (patchedPaths: string[], newData: Partial<ReactionWidgetData>) => {
        const updatedData = { ...data, ...newData }
        messagesService.send<ChangeWidgetData>("canvas.change-widget-data", {
            canvasId,
            widgetId,
            patchedPaths,
            data: updatedData as ReactionWidgetData,
        })
    }

    return { updateData }
}
